/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react';
import { Link, RouteComponentProps, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactPlayer from 'react-player';
import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';
import { AsideBook } from '../../_layout/aside-book';
import { ReducerType } from '../../_store';
import { Category } from '../../_store/slice/book-categories';
import { FormatToComma } from '../../_component/format-to-comma';

type Params = {
  id: number;
};

export function BookDetail(props: RouteComponentProps) {
  const { match } = props;
  const [bookDetail = [], setBootDetail] = useState<any>();
  const { id } = match.params as Params;
  const [possibleText, setPossibleText] = useState<string>('');
  const [impossibleText, setImPossibleText] = useState<string>('');
  const [bookCode, setBookCode] = useState<number>(0);
  const [categoryCode, setCategoryCode] = useState<number>(0);
  const [bookName, setBookName] = useState<string>('');
  const [bookImage, setBookImage] = useState<string>('');
  const [bookqty, setBookQty] = useState<number>(1);
  const [bookPrice, setBookPrice] = useState<number>(0);
  const [oneBookCode, setOneBookCode] = useState<string>('');
  const [oneBookName, setOneBookName] = useState<string>('');
  const [oneBookImage, setOneBookImage] = useState<string>('');
  const [oneBookQty, setOneBookQty] = useState<number>(1);
  const [oneBookPrice, setOneBookPrice] = useState<string>('');
  const [imgurl, setImgUrl] = useState<string>('');
  const [delivery, setDelivery] = useState<number>(0);
  const [totalQty, setTotalQty] = useState<number>(1);
  const [imageDetail, setImageDetail] = useState<any>('');
  const [youTube, setYouTube] = useState<string>('');
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    getBookDetail();
    getRefund();
    getDeliveryAmount();
  }, []);

  const getBookDetail = async () => {
    await server
      .getBookDetail(id)
      .then((payload) => {
        if (payload.imageDetail) {
          setImageDetail(`${process.env.REACT_APP_API_URL}/public/${payload?.imageDetailUrl}`);
        }
        setImgUrl(`${process.env.REACT_APP_API_URL}/public/${payload.imageMiddleUrl}`);
        setBootDetail(payload);
        setBookCode(payload.id);
        setCategoryCode(payload.categoryId);
        setBookName(payload.name);
        setBookImage(`${process.env.REACT_APP_API_URL}/public${payload.imageMiddleUrl}`);
        setBookPrice(Number(payload.price));
        // 단일 구매
        setOneBookCode(payload.id);
        setOneBookName(payload.name);
        setOneBookImage(`${process.env.REACT_APP_API_URL}/public${payload.imageMiddleUrl}`);
        setOneBookPrice(payload.price);
        // 유튜브
        setYouTube(payload.urlYoutube);
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
    // 품절 여부 확인 API 호출
    await server
      .getBookDetail(id)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setTotalQty(Number(payload.qty));
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };
  const bookCategories = useSelector<ReducerType, Category>((state) => state.bookCategories);

  // 배송료 조회 API 호출
  const getDeliveryAmount = async () => {
    await server
      .getDelivery()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setDelivery(Number(payload[0].stpayDf));
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 바로구매 Param
  const oneBookParams = {
    oneBookCode,
    oneBookName,
    oneBookImage,
    oneBookQty,
    oneBookPrice,
  };

  // 장바구니 Param
  const cartParam = {
    bookCode,
    categoryCode,
    bookName,
    bookImage,
    bookqty,
    bookPrice,
  };

  // 교환/반품/환불 정보 API 호출
  const getRefund = async () => {
    await server
      .getRefund()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setPossibleText(payload.items[0].content1);
          setImPossibleText(payload.items[0].content2);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 바로구매
  const onClickOrder = async () => {
    await server
      .getUserOwn()
      .then((payload) => {
        if (payload && payload.name) {
          if (bookqty === 0) {
            dispatch(toast.info({ message: '주문수량은 최소 1권입니다.' }));
            setBookQty(0);
            setOneBookQty(0);
            return;
          }
          if (bookqty >= totalQty) {
            dispatch(toast.error({ message: '재고가 부족합니다.' }));
            return;
          }
          history.push({
            pathname: '/order/',
            state: oneBookParams,
          });
        } else {
          dispatch(toast.error({ message: '바로구매는 로그인이 필요합니다.' }));
        }
      })
      .catch((e: Error) => console.log(e));
  };

  // 장바구니 추가 API 호출
  const onClickCart = async () => {
    if (bookqty === 0) {
      dispatch(toast.info({ message: '주문수량은 최소 1권입니다.' }));
      setBookQty(0);
      setOneBookQty(0);
      return;
    }
    if (window.localStorage.getItem('token') === null) {
      dispatch(toast.error({ message: '장바구니는 로그인이 필요합니다.' }));
      return;
    }
    if (totalQty >= bookqty) {
      await server
        .postCart(cartParam)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            dispatch(toast.info({ message: '장바구니에 추가되었습니다.' }));
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    } else {
      dispatch(toast.error({ message: '재고가 부족합니다.' }));
      return;
    }
    props.history.goBack();
  };

  return (
    <main className="sub wrapper">
      <AsideBook />
      <div className="content">
        <div className="breadscrumb">
          <>Home</>
          {' > '}
          {bookCategories.categories.map((category: any, i: any) => (
            <span key={category.id}>
              <> {category.id === bookDetail.categoryId ? category.name : ''}</>
              {bookCategories.subCategories[i].map((book: any) => (
                <span key={Math.random()}>
                  {book.id === bookDetail.categoryId ? book.name : ''}
                </span>
              ))}
            </span>
          ))}
        </div>
        <div className="details">
          <div className="book-image">
            <img src={imgurl} alt={bookDetail.name} />
          </div>
          <ul>
            <li className="title">
              <h2>{bookDetail.name}</h2>
              <div>
                <span>{bookDetail.author}</span>
                <span>{new Date(bookDetail.publicationDate).toLocaleDateString() || ''}</span>
              </div>
              <div className="links">
                {bookDetail.urlYoutube === '' ? (
                  ''
                ) : (
                  <a href={bookDetail.urlYoutube} target="_blank">
                    <img src="../assets/images/ico_youtube.jpg" alt="youtube 바로가기" />
                  </a>
                )}
                {bookDetail.urlBlog === '' ? (
                  ''
                ) : (
                  <a href={bookDetail.urlBlog} target="_blank">
                    <img src="../assets/images/ico_blog.jpg" alt="블로그 바로가기" />
                  </a>
                )}
              </div>
            </li>
            <li>
              <span>ISBN</span>
              <span>{bookDetail.isbn}</span>
            </li>
            <li>
              <span>페이지수</span>
              <span>{bookDetail.pageCount}</span>
            </li>
            <li>
              <span>판형/컬러</span>
              <span>B5 / {bookDetail.isColor && bookDetail.isColor === 'N' ? '무' : '유'}</span>
            </li>
            <li>
              <span>동영상강좌 유무</span>
              <span>{bookDetail.hasVideo && bookDetail.hasVideo === 'N' ? '무' : '유'}</span>
            </li>
            <li className="price">
              <span>정가</span>
              <span>{bookDetail.price && FormatToComma(bookDetail.price)}</span>
            </li>
            <li className="quantity">
              <span className="count">주문수량</span>
              {totalQty !== 0 ? (
                <span className="count">
                  <input
                    type="number"
                    value={bookqty}
                    onChange={(event) => {
                      setBookQty(Number(event.target.value));
                      setOneBookQty(Number(event.target.value));
                    }}
                  />
                </span>
              ) : (
                <span className="sold-out">품절</span>
              )}
            </li>
            <li className="free-shipping">{delivery.toLocaleString()}원 이상 구매시 배송비 무료</li>
            {bookqty > totalQty ? (
              <li className="buttons">
                <Link to="#" onClick={() => onClickOrder()}>
                  바로구매
                </Link>
                <Link to="#" onClick={() => onClickCart()}>
                  장바구니
                </Link>
              </li>
            ) : (
              <li className="buttons">
                {bookqty >= 1 ? (
                  <Link to="#" onClick={() => onClickOrder()}>
                    바로구매
                  </Link>
                ) : (
                  <Link to="#" onClick={() => onClickOrder()}>
                    바로구매
                  </Link>
                )}
                <Link to="#" onClick={() => onClickCart()}>
                  장바구니
                </Link>
              </li>
            )}
          </ul>
        </div>
        <div className="description">
          <section>
            <h3>책 소개</h3>
            <pre dangerouslySetInnerHTML={{ __html: bookDetail.introduce }} />
            {/* <div dangerouslySetInnerHTML={bookDetail.introduce} /> */}
          </section>
          {youTube === '' ? (
            <></>
          ) : (
            <section>
              <h3>동영상</h3>
              <ReactPlayer url={youTube} width="100%" height="36em" controls />
            </section>
          )}
          <section>
            <h3>목차</h3>
            <pre dangerouslySetInnerHTML={{ __html: bookDetail.contents }} />
          </section>
          {imageDetail ? (
            <section>
              <h3>요약 설명</h3>
              <img src={`${imageDetail}`} alt="" />
            </section>
          ) : (
            ''
          )}
          <section>
            <h3>저자 소개</h3>
            <pre dangerouslySetInnerHTML={{ __html: bookDetail.authorIntroduce }} />
          </section>
          <section>
            <h3>배송 정보</h3>
            <p>배송지역 : 전국</p>
            <p>
              배송기간 : 주문일 포함 3일 이내(연휴/공휴일 제외이며, 현금 주문일 경우 입금일
              기준입니다.)
            </p>
            <p>※도서 산간, 오지 일부 지역의 경우 도선/항공료(4,000원)가 추가 될 수 있습니다.</p>
            <p>※ {delivery.toLocaleString()}원 이상 구매 시, 배송비는 무료입니다.</p>
          </section>
          <section>
            <h3>교환/반품/환불이 가능한 경우</h3>
            <pre dangerouslySetInnerHTML={{ __html: possibleText }} />
            <br />
            <br />
            <h3>교환/반품/환불이 불가능한 경우</h3>
            <pre dangerouslySetInnerHTML={{ __html: impossibleText }} />
          </section>
          {/* <section>
            <h3>관련 서적</h3>
            <div className="items">
              <Link to="1">
                <img src="assets/images/thumbnails/01.jpg" alt="샘플이미지" />
                <ul>
                  <li>뷰티 트렌드</li>
                  <li>홍수남 권오혁</li>
                  <li>16,000원</li>
                </ul>
              </Link>
            </div>
          </section> */}
        </div>
      </div>
    </main>
  );
}
